import { render, staticRenderFns } from "./XqkczlData.vue?vue&type=template&id=7c3cfd11&scoped=true&"
import script from "./XqkczlData.vue?vue&type=script&lang=js&"
export * from "./XqkczlData.vue?vue&type=script&lang=js&"
import style0 from "./XqkczlData.vue?vue&type=style&index=0&id=7c3cfd11&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3cfd11",
  null
  
)

export default component.exports